export default __webpack_public_path__ + "img/26763e648a1a2564a65d773d8e018f58.svg";